import BasePage from "pages/base_page"
import party from "party-js"

export default class EditorialArticleFinishedPage extends BasePage {
  initialize() {
    super.initialize()

    party.resolvableShapes["tree"] = '<span style="font-size: 3em;">🎄</span>'
    party.resolvableShapes["santa"] = '<span style="font-size: 3em;">🎅</span>'
    party.resolvableShapes["gift"] = '<span style="font-size: 3em;">🎁</span>'
    party.resolvableShapes["menorah"] = '<span style="font-size: 3em;">🕎</span>'

    this.confettiWhenFinished()
    this.celebrateMoreButton()
  }

  confettiWhenFinished() {
    const origin = document.querySelector("article")
    this.confetti({ origin, min: 200, max: 200 })
  }

  celebrateMoreButton() {
    const origin = document.querySelector("article")
    const celebrateMoreButton = document.querySelector(".celebrate-more")

    celebrateMoreButton.addEventListener("click", () => {
      this.confetti({ origin, min: 200, max: 200 })
    })
  }

  confetti({ origin, min = 50, max = 100 }) {
    party.confetti(origin, {
      count: party.variation.range(min, max),
      size: party.variation.range(0.8, 1.2),
      shapes: ["tree", "santa", "gift", "menorah"],
    })
  }
}
